import { useState } from 'react';

import useStateHandler from '@/hooks/useStateHandler';
import AdminService from '@/services/admin.service';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Heading from '@/shared-components/text/components/Heading';
import Text from '@/shared-components/text/components/Text';

import './styles/RequestChangesLimitedEditionRequestPopup.css';

export default function RequestChangesLimitedEditionRequestPopup({ open, setOpen, limitedEditionInfo }) {
  const { cacheHandler } = useStateHandler();
  const [loading, setLoading] = useState(false);

  async function requestChangesLimitedEditionRequestAndNotifyChanges(e) {
    e.preventDefault();

    const reason = e.target.request_changes_gallery_request_reason.value.trim();

    if (reason === "") {
      alert("Please enter a reason for requesting changes.");
      return;
    }

    setLoading(true);
    const { response } = await AdminService.requestChangesLimitedEditionRequestAndNotifyChanges(limitedEditionInfo._id, reason);
    setLoading(false);

    if(response.ok) {
      alert("Request declined successfully.");
      cacheHandler.triggerAction("LIMITED_EDITION_REQUEST_CHANGES");
      setOpen(false);
    } else {
      alert("Something went wrong. It could be due to two reasons: either you haven't entered any rejection message, or the servers have failed.");
    }
  }

  return (
    <>
      <GenericPopup className="request-changes-gallery-request-popup" open={open} opacity>
        <XIcon className="request-changes-galery-request-close-button" onClick={()=>setOpen(false)}/>
        <h2 className="request-changes-gallery-request__heading"><Heading medium>You have chosen to request changes for the Limited Edition of the artwork: {limitedEditionInfo.artwork_about.artwork_title}</Heading></h2>
        <Text className="request-changes-gallery-request__text" large>Please specify the required changes below. The gallery will be notified:</Text>

        <form onSubmit={requestChangesLimitedEditionRequestAndNotifyChanges} className="request-changes-gallery-request_form">
          <textarea className="request-changes-gallery-request_form-textarea" name="request_changes_gallery_request_reason"autoComplete='off'></textarea>
          <button className="request-changes-gallery-request__form-button" disabled={loading}>
            {loading ? "Loading..." : "Require changes"}
          </button>
        </form>
      </GenericPopup>
    </>
  );
}
